import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs/Observable';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import * as _ from 'underscore';
import * as Chart from 'chart.js'

@Component({
	selector: 'app-update-company',
	templateUrl: './update-company.component.html',
	styleUrls: ['./update-company.component.css'],
})

export class UpdateCompanyComponent implements OnInit {
	chartRef;
	private toasterService: ToasterService;
	company: any;
	userName = '';

	partnerAgenciesAll = [];
	partnerAgencies = [];
	partnerAgenciesPages = [];
	partnerAgencyCurrentPage = 1;
	partnerAgencyLimit = 5;
	partnerAgencySkip = 0;

	nonPartnerAgency = '';
	nonPartnerAgenciesAll = [];
	nonPartnerAgencies = [];
	nonPartnerAgenciesPages = [];
	nonPartnerAgencyCurrentPage = 1;
	nonPartnerAgencyLimit = 5;
	nonPartnerAgencySkip = 0;

	name = '';
	address = '';
	email = '';
	companyLogo = '';
	status: any;
	statusName = ' ';
	company_id = '';
	access_token_nv_admin = '';
	activeUsersCount: any;
	billingCycleDate: any;
	isTestingCompany: boolean;
	file = '';
	logo = '';
	sendBillingToNovagems: any;
	sendBillingToClient: any;
	language = "en";
	error_userName = '';
	error_name = '';
	error_email = '';
	error_companyLogo = '';
	error_updatePackage = '';
	error_language= "";
	patrol_enabled: any = false;
	dispatch_enabled: any = false;
	chat_enabled: any = false;
	dashboard_enabled: any = false;
	openshift_enabled: any = false;
	ScheduleEnhancement_enabled: any = false;
	clockInOut_enabled: any = false;
	billingDate: any;
	startDate: any = new Date();
	endDate: any;
	dates: any = {};
	guardCountData: any = {};
	password = '';
	paginatedDate: any = [];
	limit = 10;
	skip = 0;
	public pages: any = [];
	currentPage = 1;
	chart: any;
	totalVariableUserCount:any;

	public startDatePickerOptions: IMyDpOptions = {
		showClearDateBtn: false,
		dateFormat: 'mmm, dd yyyy',
	};
	public endDatePickerOptions: IMyDpOptions = {
		showClearDateBtn: false,
		dateFormat: 'mmm, dd yyyy'
	};
	options: any;
	router: Router;
	startPayrollDate:any;
	endPayrollDate:any;
	constructor(private apiService: ApiService, toasterService: ToasterService, router: Router) {
		this.router = router;
		this.toasterService = toasterService;
		this.company_id = sessionStorage.getItem("company_id");

		if (sessionStorage.getItem('company_id') == '') {
			window.open("/login", "_self");
		} else {
			this.apiService.getCompany(sessionStorage.getItem("company_id")).subscribe((data:any) => {
				this.company = data.data;
				this.partnerAgenciesAll = _.sortBy(data.data.partnerAgencies, (x) => { return x.name.toLowerCase() });
				this.partnerAgencies = this.partnerAgenciesAll.slice((this.partnerAgencyCurrentPage - 1) * this.partnerAgencyLimit, this.partnerAgencyLimit);
				this.partnerAgenciesPages = [];
				let length = Math.ceil(this.partnerAgenciesAll.length / this.partnerAgencyLimit);
				for (let i = 1; i <= length; i++) {
					this.partnerAgenciesPages.push(i);
				}
				this.language = data.data.language;
				this.activeUsersCount = this.company.activeUsersCount;
				this.billingCycleDate = this.company.billingCycleDate;
				this.isTestingCompany = this.company.isTestingCompany;
				this.sendBillingToNovagems = this.company.sendBillingToNovagems;
				this.sendBillingToClient = this.company.sendBillingToClient;
				this.status = data.data.isDisable ? false : true;
				
				if (this.status) this.statusName = 'Disabled'
				else this.statusName = 'Enabled'
				this.billingDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').add(1, 'months') : moment().date(this.company.billingCycleDate).startOf('day');
				this.dates.startDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').format('YYYY-MM-DD') : moment().date(this.company.billingCycleDate).startOf('day').subtract(1, 'months').format('YYYY-MM-DD');
				this.dates.endDate = moment().startOf('day').format('YYYY-MM-DD');


				this.startDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').toObject() : moment().date(this.company.billingCycleDate).startOf('day').subtract(1, 'months').toObject();
				this.startDate = { date: { year: this.startDate.years, month: this.startDate.months + 1, day: this.startDate.date } };
				this.endDate = moment().startOf('day').toObject();
				this.endDate = { date: { year: this.endDate.years, month: this.endDate.months + 1, day: this.endDate.date } };
				this.endDatePickerOptions = {
					showClearDateBtn: false,
					dateFormat: 'mmm, dd yyyy',
					disableUntil: this.startDate.date
				};
				this.startDatePickerOptions = {
					showClearDateBtn: false,
					dateFormat: 'mmm, dd yyyy',
					disableSince: this.endDate.date
				};

				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('PATROL') > -1) {
					this.patrol_enabled = true;
				} else {
					this.patrol_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('DISPATCH') > -1) {
					this.dispatch_enabled = true;
				} else {
					this.dispatch_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('CHAT') > -1) {
					this.chat_enabled = true;
				} else {
					this.chat_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('DASHBOARD') > -1) {
					this.dashboard_enabled = true;
				} else {
					this.dashboard_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('OPENSHIFT') > -1) {
					this.openshift_enabled = true;
				} else {
					this.openshift_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('SCHEDULE_ENHANCEMENT') > -1) {
					this.ScheduleEnhancement_enabled = true;
				} else {
					this.ScheduleEnhancement_enabled = false;
				}
				if (this.company.enabledFeatures && this.company.enabledFeatures.indexOf('CLOCKINOUT') > -1) {
					this.clockInOut_enabled = true;
				} else {
					this.clockInOut_enabled = false;
				}

				this.apiService.getActiveGuardCounts(sessionStorage.getItem("company_id"), this.dates.startDate, this.dates.endDate).subscribe((data:any) =>{
					this.totalVariableUserCount = data.totalVariableUserCount;
					this.guardCountData = data.data;
					this.guardCountData.reverse();
					this.drawChart(this.guardCountData);
					var length = Math.ceil(this.guardCountData.length / this.limit);
					for (let i = 1; i <= length; i++) {
						this.pages.push(i)
					}
					this.paginatedDate = this.guardCountData.slice(0, this.limit);
				},
					error => {
						if (error.statusText == "Unauthorized") {
							// this.toasterService.pop('error', 'Session Expired', 'Please login again');
							window.open("/logout", "_self");
						} else
							 this.toasterService.pop('error', error.error.message);
					});
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});

			let formData = new FormData();
			formData.append('companyId', sessionStorage.getItem("company_id"));
			this.apiService.fetchNonPartnerDispatchEnabledAgencies(formData).subscribe((data:any) =>{
				// console.log('fetchNonPartnerDispatchEnabledAgencies data===>', data, '---data');
				this.nonPartnerAgenciesAll = _.sortBy(data.data, (x) => { return x.name.toLowerCase() });
				this.nonPartnerAgencies = this.nonPartnerAgenciesAll.slice((this.nonPartnerAgencyCurrentPage - 1) * this.nonPartnerAgencyLimit, this.nonPartnerAgencyLimit);
				this.nonPartnerAgenciesPages = [];
				let length = Math.ceil(this.nonPartnerAgenciesAll.length / this.nonPartnerAgencyLimit);
				for (let i = 1; i <= length; i++) {
					this.nonPartnerAgenciesPages.push(i);
				}
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});
		}
	}

	ngOnInit() {
		if (!sessionStorage.getItem('access_token_nv_admin')) {
			window.open("/login", "_self");
		}
	}

	searchNonPartnerAgency = () => {
		let formData = new FormData();
		formData.append('companyId', sessionStorage.getItem("company_id"));
		formData.append('companyName', this.nonPartnerAgency);
		this.apiService.fetchNonPartnerDispatchEnabledAgencies(formData).subscribe((data:any) =>{
			// console.log('fetchNonPartnerDispatchEnabledAgencies data===>', data, '---data');
			this.nonPartnerAgencies = data.data;
			this.nonPartnerAgenciesPages = [];
			let length = Math.ceil(this.nonPartnerAgencies.length / this.nonPartnerAgencyLimit);
			for (let i = 1; i <= length; i++) {
				this.nonPartnerAgenciesPages.push(i);
			}
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	drawChart(finalResponse) {
		let labels = finalResponse.map(item => moment(item.date).format('LL'));
		let data = finalResponse.map((item, i) => {
			return { x: i, y: item.guardCount }
		});
		let data2 = finalResponse.map(item => this.company.activeUsersCount);
		this.chartRef = document.getElementById('myChart');
		this.chart = new Chart(this.chartRef, {
			type: 'line',
			data: {
				labels: labels,
				datasets: [
					{
						data: data, // your data array
						borderColor: '#00AEFF',
						lineTension: 0,
						fill: false,
						label: 'Active Guard Count'
					},
					{
						data: data2, // your data array
						borderColor: '#FF0000',
						lineTension: 0,
						fill: false,
						label: 'Default Count'
					}
				]
			},
			options: {
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						display: true
					}],
					yAxes: [{
						display: true
					}],
				}
			}
		});
	}

	fileSelected(imageData) {
		this.file = imageData;
	}

	statusChange(status) {
		if (status) this.statusName = 'Disabled'
		else this.statusName = 'Enabled'
	}

	languageChange(lang) {
		if (lang) this.language = lang.target.value;
	}

	validateEmail(email) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(email)) {
			return true;
		}
		// alert("You have entered an invalid email address!")
		return false;
	}


	updateCompany() {
		let formData: FormData = new FormData();
		let isPayloadCorrect = true;
		this.email = this.email.trim();
		this.name = this.name.trim();
		this.address = this.address.trim();

		if (this.name && this.name !== "" && this.name !== this.company.userName) {
			// console.log('this.name===>', JSON.stringify(this.name), '---this.name');
			formData.append('name', this.name);
		}

		if (this.address && this.address !== "" && this.address !== this.company.address) {
			// console.log('this.name===>', JSON.stringify(this.name), '---this.name');
			formData.append('address', this.address);
		}

		if (this.email && this.email !== "") {
			if (this.email !== this.company.email) {
				if (!this.validateEmail(this.email)) {
					this.error_email = "invalid";
					isPayloadCorrect = false;
				} else {
					// console.log('this.email===>', JSON.stringify(this.email), '---this.email');
					this.error_email = "";
					formData.append('email', this.email);
				}
			}
		}
		
		if (this.hasOwnProperty('status') && this.status == this.company.isDisable) {
			// console.log('this.status===>', JSON.stringify(this.status), '---this.status');
			let status = this.status ? false : true;
			formData.append('isDisable', JSON.stringify(status));
		}

		if (this.file) {
			// console.log('this.file===>', this.file, '---this.file');
			formData.append('companyLogo', this.file);
		}

		formData.append('companyId', this.company_id);
		formData.append('language', this.language);
		console.log("this.language::::;UPDAE", this.language)
		if (isPayloadCorrect) {
			this.apiService.updateCompany(formData).subscribe((data:any) =>{
				this.company = data.data;
				this.toasterService.pop('success', data.message);
				// window.open("/home", "_self");
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});
		}
	}

	updateCompanyPackage() {
		this.apiService.updateCompanyPackage(this.company_id, this.activeUsersCount, this.billingCycleDate, this.isTestingCompany).subscribe((data:any) =>{
			this.apiService.getCompany(sessionStorage.getItem("company_id")).subscribe((data:any) =>{
				this.company = data.data;
			},
				error => {
					 this.toasterService.pop('error', error.error.message);
				});
			this.toasterService.pop('success', data.message);
			this.apiService.getCompany(sessionStorage.getItem("company_id")).subscribe((data:any) =>{
				this.company = data.data;
				this.activeUsersCount = this.company.activeUsersCount;
				this.billingCycleDate = this.company.billingCycleDate;
				this.isTestingCompany = this.company.isTestingCompany;
				this.sendBillingToNovagems = this.company.sendBillingToNovagems;
				this.sendBillingToClient = this.company.sendBillingToClient;
				this.status = data.data.isDisable;
				if (this.status) this.statusName = 'Disabled'
				else this.statusName = 'Enabled'
				this.billingDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').add(1, 'months') : moment().date(this.company.billingCycleDate).startOf('day');
				this.dates.startDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').format('YYYY-MM-DD') : moment().date(this.company.billingCycleDate).startOf('day').subtract(1, 'months').format('YYYY-MM-DD');
				this.dates.endDate = moment().startOf('day').format('YYYY-MM-DD');


				this.startDate = moment().date(this.company.billingCycleDate).startOf('day').isBefore() ? moment().date(this.company.billingCycleDate).startOf('day').toObject() : moment().date(this.company.billingCycleDate).startOf('day').subtract(1, 'months').toObject();
				this.startDate = { date: { year: this.startDate.years, month: this.startDate.months + 1, day: this.startDate.date } };
				this.endDate = moment().startOf('day').toObject();
				this.endDate = { date: { year: this.endDate.years, month: this.endDate.months + 1, day: this.endDate.date } };
				this.endDatePickerOptions = {
					showClearDateBtn: false,
					dateFormat: 'mmm, dd yyyy',
					disableUntil: this.startDate.date
				};
				this.startDatePickerOptions = {
					showClearDateBtn: false,
					dateFormat: 'mmm, dd yyyy',
					disableSince: this.endDate.date
				};
				this.apiService.getActiveGuardCounts(sessionStorage.getItem("company_id"), this.dates.startDate, this.dates.endDate).subscribe((data:any) =>{
					this.guardCountData = data.data;
					this.guardCountData.reverse();
					this.drawChart(this.guardCountData);
					this.pages = [];
					var length = Math.ceil(this.guardCountData.length / this.limit);
					for (let i = 1; i <= length; i++) {
						this.pages.push(i)
					}
					this.paginatedDate = this.guardCountData.slice(0, this.limit);
				},
					error => {
						if (error.statusText == "Unauthorized") {
							// this.toasterService.pop('error', 'Session Expired', 'Please login again');
							window.open("/logout", "_self");
						} else
							 this.toasterService.pop('error', error.error.message);
					});
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else
						 this.toasterService.pop('error', error.error.message);
				});
			// window.open("/home", "_self");
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	resetCompanyPassword() {
		this.apiService.resetCompanyPassword(this.company_id, this.password).subscribe((data:any) =>{
			this.toasterService.pop('success', data.message);
			window.open("/home", "_self");
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	getActiveGuardCounts() {
		var startDate = JSON.parse(JSON.stringify(this.startDate));
		var endDate = JSON.parse(JSON.stringify(this.endDate));
		startDate.date.month -= 1;
		endDate.date.month -= 1;
		this.apiService.getActiveGuardCounts(sessionStorage.getItem("company_id"), moment(startDate.date).format('YYYY-MM-DD'), moment(endDate.date).format('YYYY-MM-DD')).subscribe((data:any) =>{
			this.guardCountData = data.data;
			this.guardCountData.reverse();
			this.drawChart(this.guardCountData);
			var length = Math.ceil(this.guardCountData.length / this.limit);
			this.pages = [];
			for (let i = 1; i <= length; i++) {
				this.pages.push(i)
			}
			this.paginatedDate = this.guardCountData.slice(0, this.limit);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	updateSendToNovagems() {
		this.apiService.updateSendToNovagems(this.company_id, !this.sendBillingToNovagems).subscribe((data:any) =>{
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	updateSendToClient() {
		this.apiService.updateSendToClient(this.company_id, !this.sendBillingToClient).subscribe((data:any) =>{
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showEnableDisablePatrol = () => {
		let str = this.patrol_enabled ? 'disable' : 'enable';
		let patrolPrompt = prompt(`Please enter the company name to ${str} the feature: PATROL\n\nNote: Company name is case sensetive`);
		if (patrolPrompt == null) {
		} else if (patrolPrompt) this.enableDisablePatrol(patrolPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisablePatrol(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('patrolEnabled', this.patrol_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisablePatrol(formData).subscribe((data:any) =>{
			if (this.patrol_enabled) {
				let indexOfDispatch = this.company.enabledFeatures.indexOf('PATROL');
				if (indexOfDispatch != -1) this.company.enabledFeatures.splice(indexOfDispatch, 1);
				this.patrol_enabled = false;
			} else {
				this.company.enabledFeatures.push('PATROL');
				this.patrol_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showEnableDisableDispatch = () => {
		let str = this.dispatch_enabled ? 'disable' : 'enable';
		let dispatchPrompt = prompt(`Please enter the company name to ${str} the feature: DISPATCH\n\nNote: Company name is case sensetive`);
		if (dispatchPrompt == null) {
		} else if (dispatchPrompt) this.enableDisableDispatch(dispatchPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableDispatch(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('dispatchEnabled', this.dispatch_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableDispatch(formData).subscribe((data:any) =>{
			if (this.dispatch_enabled) {
				let indexOfDispatch = this.company.enabledFeatures.indexOf('DISPATCH');
				if (indexOfDispatch != -1) this.company.enabledFeatures.splice(indexOfDispatch, 1);
				this.dispatch_enabled = false;
			} else {
				this.company.enabledFeatures.push('DISPATCH');
				this.dispatch_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showEnableDisableChat = () => {
		let str = this.chat_enabled ? 'disable' : 'enable';
		let chatPrompt = prompt(`Please enter the company name to ${str} the feature: CHAT\n\nNote: Company name is case sensetive`);
		if (chatPrompt == null) {
		} else if (chatPrompt) this.enableDisableChat(chatPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableChat(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('isChatEnabled', this.chat_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableChat(formData).subscribe((data:any) =>{
			if (this.chat_enabled) {
				let indexOfChat = this.company.enabledFeatures.indexOf('CHAT');
				if (indexOfChat != -1) this.company.enabledFeatures.splice(indexOfChat, 1);
				this.chat_enabled = false;
			} else {
				this.company.enabledFeatures.push('CHAT');
				this.chat_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showEnableDisableDashboard = () => {
		let str = this.dashboard_enabled ? 'disable' : 'enable';
		let dashboardPrompt = prompt(`Please enter the company name to ${str} the feature: Dashboard\n\nNote: Company name is case sensetive`);
		if (dashboardPrompt == null) {
		} else if (dashboardPrompt) this.enableDisableDashboard(dashboardPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableDashboard(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('isDashboardEnabled', this.dashboard_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableDashboard(formData).subscribe((data:any) =>{
			if (this.dashboard_enabled) {
				let indexOfDashboard = this.company.enabledFeatures.indexOf('DASHBOARD');
				if (indexOfDashboard != -1) this.company.enabledFeatures.splice(indexOfDashboard, 1);
				this.dashboard_enabled = false;
			} else {
				this.company.enabledFeatures.push('DASHBOARD');
				this.dashboard_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showEnableDisableOpenShift = () => {
		let str = this.openshift_enabled ? 'disable' : 'enable';
		let openShiftPrompt = prompt(`Please enter the company name to ${str} the feature: Open Shift\n\nNote: Company name is case sensetive`);
		if (openShiftPrompt == null) {
		} else if (openShiftPrompt) this.enableDisableOpenShift(openShiftPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableOpenShift(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('isOpenShiftEnabled', this.openshift_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableOpenShift(formData).subscribe((data:any) =>{
			if (this.openshift_enabled) {
				let indexOfOpenShift = this.company.enabledFeatures.indexOf('OPENSHIFT');
				if (indexOfOpenShift != -1) this.company.enabledFeatures.splice(indexOfOpenShift, 1);
				this.openshift_enabled = false;
			} else {
				this.company.enabledFeatures.push('OPENSHIFT');
				this.openshift_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}
	showEnableDisableScheduleEnhancement = () => {
		let str = this.ScheduleEnhancement_enabled ? 'disable' : 'enable';
		let ScheduleEnhancementPrompt = prompt(`Please enter the company name to ${str} the feature: Schedule Enhancemement\n\nNote: Company name is case sensetive`);
		if (ScheduleEnhancementPrompt == null) {
		} else if (ScheduleEnhancementPrompt) this.enableDisableScheduleEnhancement(ScheduleEnhancementPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableScheduleEnhancement(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('isScheduleEnhancement', this.ScheduleEnhancement_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableScheduleEnhancement(formData).subscribe((data:any) =>{
			if (this.ScheduleEnhancement_enabled) {
				let indexOfScheduleEnhancement = this.company.enabledFeatures.indexOf('SCHEDULE_ENHANCEMENT');
				if (indexOfScheduleEnhancement != -1) this.company.enabledFeatures.splice(indexOfScheduleEnhancement, 1);
				this.ScheduleEnhancement_enabled = false;
			} else {
				this.company.enabledFeatures.push('SCHEDULE_ENHANCEMENT');
				this.ScheduleEnhancement_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}


	showEnableDisableClockInOut = () => {
		let str = this.clockInOut_enabled ? 'disable' : 'enable';
		let clockInOutPrompt = prompt(`Please enter the company name to ${str} the feature: CLOCK IN-OUT\n\nNote: Company name is case sensetive\nNote: Disabling the feature will force end duties of all clocked-in guards`);
		if (clockInOutPrompt == null) {
		} else if (clockInOutPrompt) this.enableDisableClockInOut(clockInOutPrompt);
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	enableDisableClockInOut(companyName: string) {
		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('clockInOutEnabled', this.clockInOut_enabled ? "false" : "true");
		formData.append('companyName', companyName);
		this.apiService.enableDisableClockInOut(formData).subscribe((data:any) => {
			if (this.clockInOut_enabled) {
				let indexOfClockInOut = this.company.enabledFeatures.indexOf('CLOCKINOUT');
				if (indexOfClockInOut != -1) this.company.enabledFeatures.splice(indexOfClockInOut, 1);
				this.clockInOut_enabled = false;
			} else {
				this.company.enabledFeatures.push('CLOCKINOUT');
				this.clockInOut_enabled = true;
			}
			this.toasterService.pop('success', data.message);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	openDownloadPage() {
		var startDate = JSON.parse(JSON.stringify(this.startDate));
		var endDate = JSON.parse(JSON.stringify(this.endDate));
		startDate.date.month--;
		endDate.date.month--;
		this.router.navigate(['/billing', this.company._id, moment(startDate.date).format('YYYY-MM-DD'), moment(endDate.date).format('YYYY-MM-DD')]);
	}

	setPage(page) {
		this.currentPage = page;
		this.skip = (this.currentPage - 1) * this.limit;
		this.paginatedDate = this.guardCountData.slice(this.skip, this.skip + this.limit);
	}

	setPageForNonPartnerAgency(page) {
		this.nonPartnerAgencyCurrentPage = page;
		this.nonPartnerAgencySkip = (this.nonPartnerAgencyCurrentPage - 1) * this.nonPartnerAgencyLimit;
		this.nonPartnerAgencies = this.nonPartnerAgenciesAll.slice(this.nonPartnerAgencySkip, this.nonPartnerAgencySkip + this.nonPartnerAgencyLimit);
	}

	setPageForPartnerAgency(page) {
		this.partnerAgencyCurrentPage = page;
		this.partnerAgencySkip = (this.partnerAgencyCurrentPage - 1) * this.partnerAgencyLimit;
		this.partnerAgencies = this.partnerAgenciesAll.slice(this.partnerAgencySkip, this.partnerAgencySkip + this.partnerAgencyLimit);
	}

	onStartDateChanged(event: any) {
		this.endDatePickerOptions = {
			showClearDateBtn: false,
			dateFormat: 'mmm, dd yyyy',
			disableUntil: event.date
		};
	}

	onEndDateChanged(event: any) {
		this.startDatePickerOptions = {
			showClearDateBtn: false,
			dateFormat: 'mmm, dd yyyy',
			disableSince: event.date
		};
	}

	convertDateToString(dateToBeConverted: string) {
		return moment(dateToBeConverted, "YYYY-MM-DD HH:mm:ss").format("LL");
	}

	showAddAsPartner = (agencyId: string, agencyName: string) => {
		let addAsPartnerPrompt = prompt(`Please enter the company name to add as Partner\n\nNote: Company name is case sensetive`);
		if (addAsPartnerPrompt == null) {
		} else if (agencyName == addAsPartnerPrompt) this.linkPartnerAgency(agencyId);
		else if (addAsPartnerPrompt) this.toasterService.pop('error', 'Please enter correct company name');
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	linkPartnerAgency(agencyId: string) {
		console.log('linkPartnerAgency agencyId--', agencyId);

		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('agencyId', agencyId);
		this.apiService.linkPartnerAgency(formData).subscribe((data:any) => {
			this.toasterService.pop('success', data.message);
			let indexOfAgency = _.findIndex(this.nonPartnerAgenciesAll, (agency) => agency._id == agencyId);
			if (indexOfAgency != -1) this.nonPartnerAgenciesAll[indexOfAgency].isPartnerAgency = !this.nonPartnerAgenciesAll[indexOfAgency].isPartnerAgency;

			this.moveAgencyBetweenPartnerAndNonPartnerAgency(agencyId, true);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	showRemoveAsPartner = (agencyId: string, agencyName: string) => {
		let removeAsPartnerPrompt = prompt(`Please enter the company name to remove as Partner\n\nNote: Company name is case sensetive`);
		if (removeAsPartnerPrompt == null) {
		} else if (agencyName == removeAsPartnerPrompt) this.unlinkPartnerAgency(agencyId);
		else if (agencyName != removeAsPartnerPrompt) this.toasterService.pop('error', 'Please enter correct company name');
		else this.toasterService.pop('error', 'Company name is not allowed to be empty');
	}

	unlinkPartnerAgency(agencyId: string) {
		// console.log('unlinkPartnerAgency agencyId--', agencyId);

		let formData: FormData = new FormData();
		formData.append('companyId', this.company_id);
		formData.append('agencyId', agencyId);
		this.apiService.unlinkPartnerAgency(formData).subscribe((data:any) => {
			this.toasterService.pop('success', data.message);
			let indexOfAgency = _.findIndex(this.partnerAgenciesAll, (agency) => agency._id == agencyId);
			if (indexOfAgency != -1) this.partnerAgenciesAll[indexOfAgency].isPartnerAgency = !this.partnerAgenciesAll[indexOfAgency].isPartnerAgency;

			this.moveAgencyBetweenPartnerAndNonPartnerAgency(agencyId);
		},
			error => {
				if (error.statusText == "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
	}

	moveAgencyBetweenPartnerAndNonPartnerAgency = (agencyId: string, moveToPartnerAgency: boolean = false) => {
		if (moveToPartnerAgency) {
			let indexOfAgency = _.findIndex(this.nonPartnerAgenciesAll, (agency) => agency._id == agencyId);
			if (indexOfAgency != -1) {
				let targetAgency = this.nonPartnerAgenciesAll.splice(indexOfAgency, 1);
				this.partnerAgenciesAll = [..._.sortBy([...this.partnerAgenciesAll, ...targetAgency], (x) => { return x.name.toLowerCase() })];
			}
		} else {
			let indexOfAgency = _.findIndex(this.partnerAgenciesAll, (agency) => agency._id == agencyId);
			if (indexOfAgency != -1) {
				let targetAgency = this.partnerAgenciesAll.splice(indexOfAgency, 1);
				this.nonPartnerAgenciesAll = [..._.sortBy([...this.nonPartnerAgenciesAll, ...targetAgency], (x) => { return x.name.toLowerCase() })];
			}
		}

		let partnerAgenciesSkip = (this.partnerAgencyCurrentPage - 1) * this.partnerAgencyLimit;
		if (partnerAgenciesSkip == this.partnerAgenciesAll.length && this.partnerAgencyCurrentPage != 1) {
			this.partnerAgencyCurrentPage -= 1;
		}

		this.partnerAgencies = this.partnerAgenciesAll.slice((this.partnerAgencyCurrentPage - 1) * this.partnerAgencyLimit, this.partnerAgencyLimit);
		this.partnerAgenciesPages = [];
		let length1 = Math.ceil(this.partnerAgenciesAll.length / this.partnerAgencyLimit);
		for (let i = 1; i <= length1; i++) {
			this.partnerAgenciesPages.push(i);
		}

		let nonPartnerAgenciesSkip = (this.nonPartnerAgencyCurrentPage - 1) * this.nonPartnerAgencyLimit;
		if (nonPartnerAgenciesSkip == this.nonPartnerAgenciesAll.length && this.nonPartnerAgencyCurrentPage != 1) {
			this.nonPartnerAgencyCurrentPage -= 1;
		}

		this.nonPartnerAgencies = this.nonPartnerAgenciesAll.slice((this.nonPartnerAgencyCurrentPage - 1) * this.nonPartnerAgencyLimit, this.nonPartnerAgencyLimit);
		this.nonPartnerAgenciesPages = [];
		let length2 = Math.ceil(this.nonPartnerAgenciesAll.length / this.nonPartnerAgencyLimit);
		for (let i = 1; i <= length2; i++) {
			this.nonPartnerAgenciesPages.push(i);
		}
	}

	updatePayroll(){
		console.log(this.startPayrollDate, this.endPayrollDate, this.company_id)
		if(this.startPayrollDate == null || this.startPayrollDate == undefined){
			return this.toasterService.pop('error', 'Select start date');
		}
		if(this.endPayrollDate == null || this.endPayrollDate == undefined){
			return this.toasterService.pop('error', 'Select end date');
		}

		let params:any = {
			companyId: this.company_id,
			startDate: moment(this.startPayrollDate.jsdate).format('YYYY-MM-DD'),
			endDate: moment(this.endPayrollDate.jsdate).format('YYYY-MM-DD'),
		}
		this.apiService.updatePayrollData(params).subscribe((data:any) =>{
			console.log(data);
			if(data['statusCode'] == 200){
				this.toasterService.pop('success', 'Payroll Updated Successfully');
			}else{
				this.toasterService.pop('error', data['message']);
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/components/update-company/update-company.component.ts